<template>
  <v-container style="width: 100vw !important">
    <!-- Kada razrednik nema odjeljenje prikaži alert -->
    <div v-if="$route.params.odjeljenje_id === 'none'" class="mt-10">
      <v-alert type="error">Nemate dodjeljeno nijedno odjeljenje.</v-alert>
    </div>
    <div v-else>
      <custom-heading :breadcrumbs="breadcrumbs" />

      <v-container class="mb-8">
        <v-tabs
          v-model="selected"
          style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
        >
          <v-tab
            v-for="(link, index) in navLinks"
            :key="link.title + '_' + index"
            @click="selected = index"
            style="min-width: 192px"
            >{{ link.title }}</v-tab
          >
        </v-tabs>
      </v-container>

      <div>
        <department-info v-if="selected === 0 && $checkPermission('tab_basic_data_in_department')"></department-info>
        <department-student-index
          v-if="selected === 1 && $checkPermission('tab_students_in_department')"
        ></department-student-index>
        <department-subject-index
          v-if="selected === 2 && $checkPermission('tab_subjects_in_department')"
        ></department-subject-index>
        <department-testimonial v-if="selected === 3 & $checkPermission('tab_diplomas_in_department')"></department-testimonial>
      </div>
    </div>
  </v-container>
</template>

<script>
import CustomHeading from "../heading/CustomHeading";
import DepartmentInfo from "./departmentInfo/DepartmentInfo";
import ApiV2 from "@/services/ApiV2";
import DepartmentStudentIndex from "./departmentInfo/departmentStudents/DepartmentStudentIndex";
import DepartmentSubjectIndex from "./departmentInfo/departmentSubjects/DepartmentSubjectIndex";
import DepartmentTestimonial from "./departmentInfo/DepartmentTestimonial";

export default {
  components: {
    CustomHeading,
    DepartmentInfo,
    DepartmentStudentIndex,
    DepartmentSubjectIndex,
    DepartmentTestimonial,
  },

  computed: {
    navLinks() {
      let links = [
        {title: "osnovni podaci", permission: 'tab_basic_data_in_department'},
        {title: "učenici",  permission: 'tab_students_in_department'},
        {title: "predmeti", permission: 'tab_subjects_in_department'},
        {title: "podaci o svjedodžbama", permission: 'tab_diplomas_in_department'},
      ]
      return links.filter(link => this.$checkPermission(link.permission))
    },
    currentSchool() {
      return this.$store.getters.getSchool;
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
  },
  watch: {
    currentSchool: {
      handler() {
        if (this.currentRole.role_id === 5) {
          this.$router.push("/admin");

          this.$axios.post("prijavljeni").then((response) => {
            this.$store.dispatch("setUser", response.data);
          });
        } else {
/*
          this.$store.dispatch("setSchoolFieldId", null);
          this.$router.push("/admin/odjeljenje");
*/
        }
      },
      deep: true,
    },
    selected: {
      handler() {
        localStorage.setItem("department-tab", this.selected);
      },
    },
  },

  created() {
    this.selected = this.$route.query.tab ? +this.$route.query.tab : 0;
    if (localStorage.getItem("department-tab")) {
      this.selected = parseInt(localStorage.getItem("department-tab"));
    }

    const departmentId = this.$route.params.odjeljenje_id;

    ApiV2.get(`departments/${departmentId}`).then((response) => {
      this.breadcrumbs.push({ text: response.data.label });
    });
  },

  data() {
    return {
      breadcrumbs: [
        { text: "Administracija", disabled: false },
        { text: "E-Matica", disabled: false },
        { text: "Odjeli", disabled: false, href: "/admin/odjeljenje" },
      ],
      selected:0 ,
    };
  },
};
</script>
